var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMComunidad(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#329be6;}.cls-2{fill:none;}.cls-3{fill:#fff;}.cls-4{fill:#0b5c96;}.cls-5{fill:#2eccb6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-generico"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.07,30.38,35,30.25l-2.22-3.44a.51.51,0,0,0-.92.11l-1.38,3.85-4,1a.52.52,0,0,0-.19.91l3.24,2.51-.23,4.08a.52.52,0,0,0,.81.46l3.38-2.3L37.32,39a.52.52,0,0,0,.69-.63L36.86,34.4l2.59-3.17A.52.52,0,0,0,39.07,30.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.07,30.38,35,30.25l-2.22-3.44a.51.51,0,0,0-.92.11l-1.38,3.85-4,1a.52.52,0,0,0-.19.91l3.24,2.51-.23,4.08a.52.52,0,0,0,.81.46l3.38-2.3L37.32,39a.52.52,0,0,0,.69-.63L36.86,34.4l2.59-3.17A.52.52,0,0,0,39.07,30.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.51,36.12c-.23,0-.46,0-.68,0a6,6,0,0,1-.67-11.92l-.91-8L44.83,17.56l.5,4.34a.41.41,0,0,1-.36.44l-1.69.19a.39.39,0,0,1-.44-.35l-.49-4.33L6.59,21.91l.9,8c.23,0,.46,0,.68,0a6,6,0,0,1,.67,11.92l.91,8,35.76-4.06L45,41.34a.4.4,0,0,1,.35-.45l1.69-.19a.4.4,0,0,1,.44.35l.5,4.34,11.41-1.3ZM39.45,31.23,36.86,34.4,38,38.32a.52.52,0,0,1-.69.63l-3.81-1.48-3.38,2.3a.52.52,0,0,1-.81-.46l.23-4.08-3.24-2.51a.52.52,0,0,1,.19-.91l4-1,1.38-3.85a.51.51,0,0,1,.92-.11L35,30.25l4.09.13A.52.52,0,0,1,39.45,31.23Zm4.29-1.1-.53-4.69a.4.4,0,0,1,.35-.44l1.69-.2a.42.42,0,0,1,.45.36l.53,4.69a.4.4,0,0,1-.35.44l-1.69.19A.4.4,0,0,1,43.74,30.13Zm3,8.11-1.69.19a.4.4,0,0,1-.44-.35l-.54-4.69a.42.42,0,0,1,.36-.45l1.69-.19a.41.41,0,0,1,.44.36l.53,4.68A.4.4,0,0,1,46.78,38.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 43.47,
    y: 24.88,
    width: 2.5,
    height: 5.52,
    rx: 0.4,
    transform: "translate(-2.84 5.23) rotate(-6.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 44.37,
    y: 32.83,
    width: 2.5,
    height: 5.52,
    rx: 0.4,
    transform: "translate(-3.73 5.38) rotate(-6.48)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.75 49.73 16.02 49.02 8.85 41.85 9.75 49.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "49.98 16.98 57.15 24.15 56.25 16.27 49.98 16.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "59.41 44.09 58.95 40.05 54.33 44.67 59.41 44.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.59 21.91 7.05 25.95 11.67 21.33 6.59 21.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M10.43,38.46a3.51,3.51,0,0,0,1.19-3,3.47,3.47,0,0,0-3.45-3.08l-.39,0-2.1.24a.39.39,0,0,1-.44-.35L5,30.16l-.22-1.94-4.5,4.5a.4.4,0,0,0,0,.56L6.5,39.5l1.93-.21A3.72,3.72,0,0,0,10.43,38.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32.72,65.72a.4.4,0,0,0,.56,0L51.49,47.51l-33.2,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M33.28.28a.4.4,0,0,0-.56,0L14.51,18.49l33.2-3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.72,32.72,59.5,26.5l-1.93.21a3.72,3.72,0,0,0-2,.83,3.51,3.51,0,0,0-1.19,3,3.47,3.47,0,0,0,3.45,3.08l.39,0,2.1-.24a.39.39,0,0,1,.44.35l.24,2.1.22,1.94,4.5-4.5A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.41,44.09l-5.08.58-2.84,2.84,8.21-.93,2.09-.24a.39.39,0,0,0,.35-.44l-.23-2.09-.69-6L59,40.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.75,49.73l-.9-7.88L6.5,39.5h0a.4.4,0,0,0-.35.44l.24,2.1.91,8,.23,2.09a.4.4,0,0,0,.45.35L10,52.22l8.26-.93L16,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.25,16.27l.9,7.88L59.5,26.5h0a.4.4,0,0,0,.35-.44L59.65,24l-.91-8-.23-2.09a.4.4,0,0,0-.45-.35L56,13.78l-8.26.93L50,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.59,21.91l5.08-.58,2.84-2.84-8.21.93-2.09.24a.39.39,0,0,0-.35.44l.23,2.09.69,6L7.05,26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8.84,41.76a6,6,0,0,0-.67-11.92c-.22,0-.45,0-.68,0L7.05,26,4.78,28.22,5,30.16l.24,2.1a.39.39,0,0,0,.44.35l2.1-.24.39,0a3.47,3.47,0,0,1,3.45,3.08,3.51,3.51,0,0,1-1.19,3,3.72,3.72,0,0,1-2,.83L6.5,39.5l2.35,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M60.76,33.74a.39.39,0,0,0-.44-.35l-2.1.24-.39,0a3.47,3.47,0,0,1-3.45-3.08,3.51,3.51,0,0,1,1.19-3,3.72,3.72,0,0,1,2-.83l1.93-.21-2.35-2.35v.09a6,6,0,0,0,.67,11.92c.22,0,.45,0,.68,0L59,40.05l2.27-2.27L61,35.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48,45.39l-.5-4.34a.4.4,0,0,0-.44-.35l-1.69.19a.4.4,0,0,0-.35.45l.49,4.33L16,49l2.27,2.27,33.2-3.78,2.84-2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.35,17.85l.49,4.33a.39.39,0,0,0,.44.35L45,22.34a.41.41,0,0,0,.36-.44l-.5-4.33L50,17l-2.27-2.27-33.2,3.78-2.84,2.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMComunidad);
export default __webpack_public_path__ + "static/media/m_comunidad.47960c46757459c57502f3c8319d0160.svg";
export { ForwardRef as ReactComponent };